import { render, staticRenderFns } from "./KeywordsCard.vue?vue&type=template&id=26154a23&scoped=true"
import script from "./KeywordsCard.vue?vue&type=script&lang=js"
export * from "./KeywordsCard.vue?vue&type=script&lang=js"
import style0 from "./KeywordsCard.vue?vue&type=style&index=0&id=26154a23&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26154a23",
  null
  
)

export default component.exports